import React from "react";
import * as Tooltip from "@radix-ui/react-tooltip";

const LightTooltip = ({
  title,
  children,
  side = "bottom",
  align = "center",
  className = "",
  sideOffset = 0,
  delayDuration = 150,
  variant = "light"
}) => {
  const variantClasses = variant === "dark" ? "bg-secondary-2 text-white" : "bg-white text-black";
  const arrowFillClass = variant === "dark" ? "fill-secondary-2" : "fill-white";

  return (
    <Tooltip.Provider delayDuration={delayDuration}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
        <Tooltip.Content
          side={side}
          align={align}
          sideOffset={sideOffset}
          className={`${variantClasses} text-[13px] shadow-md px-2.5 py-1.5 rounded-md z-[9999] relative ${className}`}
        >
          {title}
          <Tooltip.Arrow className={`${arrowFillClass} shadow-md`} />
        </Tooltip.Content>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};

export { LightTooltip };
